import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface UserTicket {
  id: number;
  childTicket: string;
  motorInvestigationTicketStatusId: number;
  targetDate: string;
  type: string;
  serialNumber: string;
  oldMotorPn: number;
  motorProductionDate: string;
  priority: string;
  machineName: string;
  ticketStatus: string;
}

export interface UserTicketListResponse {
  totalResult: number;
  page: number;
  pageSize: number;
  totalPages: number;
  motorInvestigationTickets: UserTicket[];
}

export interface FetchUserTicketListParams {
  UserEmail?: string;
  Page?: number;
  Limit?: number;
  Sort?: string;
  Order?: string;
  ChildTicket?: string;
  MotorType?: string;
  SerialNumber?: string;
  OldMotorPn?: number;
  ProductionDate?: string;
  Priority?: string;
  MachineName?: string;
  MotorInvestigationTicketStatusId?: number;
  [key: string]: string | number | undefined;
}

const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL environment variable is not set');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

export const userTicketListApiSlice = createApi({
  reducerPath: 'userTicketListApi',
  baseQuery: baseQuery,
  tagTypes: ['UserTickets'],
  endpoints(builders) {
    return {
      fetchUserTicketList: builders.query<UserTicketListResponse, FetchUserTicketListParams | void>({
        query: (params) => {
          let queryString = '';
          if (params) {
            const usp = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== '') {
                usp.append(key, String(value));
              }
            });
            queryString = usp.toString() ? `?${usp.toString()}` : '';
          }
          return {
            url: `${API_URLS.USER_TICKET.SEARCH}${queryString}`,
            method: 'GET',
          };
        },
        providesTags: ['UserTickets'],
        transformErrorResponse: transformApiError,
      }),
      addFollower: builders.mutation<any, { ticketNumber: string, followerEmail: string }>({
              query({ ticketNumber, followerEmail }) {
                return {
                  url: `${API_URLS.USER_TICKET.ADD_FOLLOWER}?childTicket=${ticketNumber}&followerEmail=${followerEmail}`,
                  method: 'POST',
                };
              },
              invalidatesTags: ['UserTickets'],
              transformErrorResponse: transformApiError,
            }),
    };
  },
});

export const { useFetchUserTicketListQuery, useAddFollowerMutation } = userTicketListApiSlice;
